const activityPage = document.querySelector('.page-node-type-activity');

const resizeMainContainerOnChange = (contentEntriesContainer, contents, entryIndex) => {
  contentEntriesContainer.style.height = `${contents[entryIndex].offsetHeight + 30}px`;
};

const handleMenuEntryClicked = () => {
  const entries = activityPage.querySelectorAll('.head .entries li');
  const contentEntriesContainer = activityPage.querySelector('.content .entries');

  if (!contentEntriesContainer) {
    return;
  }

  const contents = contentEntriesContainer.querySelectorAll('.entry');
  resizeMainContainerOnChange(contentEntriesContainer, contents, 0);
  entries.forEach(entry => {
    entry.addEventListener('click', () => {
      const index = Array.from(entry.parentNode.children).indexOf(entry);
      entries.forEach(entry => entry.classList.remove('current'));
      contents.forEach(content => content.classList.remove('current'));
      entry.classList.add('current');
      contents[index].classList.add('current');
      resizeMainContainerOnChange(contentEntriesContainer, contents, index);
    });
  });
};

activityPage && handleMenuEntryClicked();
